import { useQuery } from "@tanstack/react-query";
import { me } from "../services/api";
import useAuth from "./useAuth";

// Custom Hook
export const useCurrentUser = (userId) => {
  const { isAuthenticated } = useAuth();
  const {
    isPending: isUserLoading,
    error: isUserError,
    refetch: refetchMe,
    data: userData,
  } = useQuery({
    queryKey: ["userData"], // Unique query key for caching
    queryFn: me,
    retry: 2,
    enabled: !!isAuthenticated,
  });

  return { userData, refetchMe, isUserLoading };
};
